import { buildPastedImageName } from './buildPastedImageName'

type IHtmlClipboardImages = {
  urls: string[]
  files: File[]
  alts: string[]
}

const dataUrlToImageFile = (dataUrl: string, index: number, total: number): File | null => {
  const match = dataUrl.match(/^data:(image\/[a-zA-Z0-9.+-]+);base64,(.*)$/)

  if (!match) return null

  const [, type, base64] = match

  try {
    const binary = atob(base64)
    const bytes = new Uint8Array(binary.length)

    for (let i = 0; i < binary.length; i += 1) {
      bytes[i] = binary.charCodeAt(i)
    }

    return new File([bytes], buildPastedImageName(type, index, total), { type })
  } catch {
    return null
  }
}

export const getHtmlClipboardImages = (html: string): IHtmlClipboardImages => {
  const result: IHtmlClipboardImages = { urls: [], files: [], alts: [] }

  if (!html) return result

  const doc = new DOMParser().parseFromString(html, 'text/html')
  const images = Array.from(doc.querySelectorAll('img'))

  images.forEach((img, index) => {
    const src = img.getAttribute('src') || ''
    const alt = (img.getAttribute('alt') || '').trim()

    if (alt) result.alts.push(alt)

    if (/^https?:\/\//i.test(src)) {
      result.urls.push(src)
    } else if (src.startsWith('data:')) {
      const file = dataUrlToImageFile(src, index, images.length)
      if (file) result.files.push(file)
    }
  })

  return result
}

export const removeImageAltLines = (text: string, alts: string[]): string => {
  const altSet = new Set(alts.map((alt) => alt.trim()).filter(Boolean))
  if (!altSet.size) return text

  const lines = text.split('\n')
  const kept: string[] = []

  for (let i = 0; i < lines.length; i += 1) {
    const line = lines[i]

    if (altSet.has(line.trim())) {
      const prev = kept[kept.length - 1]
      const next = lines[i + 1]

      if (prev !== undefined && !prev.trim() && next !== undefined && !next.trim()) {
        i += 1
      }

      continue
    }

    kept.push(line)
  }

  return kept.join('\n').trim()
}
